import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Ved = ({
  size,
  type,
  theme,
  className,
  dataTestId = "ved-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M10.247 7.333c-.065-1.608-.363-3.028-.793-4.064-.245-.59-.52-1.024-.79-1.3-.27-.274-.494-.354-.665-.354V.28c.637 0 1.184.314 1.616.754.43.438.785 1.037 1.07 1.723.508 1.222.83 2.822.896 4.575H15.2v1.334h-3.618c-.066 1.753-.388 3.353-.896 4.575-.285.686-.64 1.284-1.07 1.722-.432.44-.979.754-1.616.754v-1.333c.171 0 .395-.081.664-.355.271-.276.546-.71.79-1.3.43-1.036.729-2.455.794-4.063H.802V7.333h9.445Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 15.718A7.718 7.718 0 0 0 8 .28a7.718 7.718 0 0 0 0 15.437ZM8 1.615c-.17 0-.394.08-.663.354-.271.276-.546.71-.79 1.3-.49 1.177-.807 2.85-.807 4.73 0 1.882.317 3.554.806 4.731.245.59.52 1.024.79 1.3.27.274.494.355.665.355a6.385 6.385 0 0 0 0-12.77ZM5.647 13.937a7.248 7.248 0 0 1-.331-.695c-.571-1.376-.909-3.23-.909-5.242 0-2.013.338-3.867.909-5.242.101-.244.211-.477.33-.696a6.387 6.387 0 0 0 0 11.875Z"
    />
  </SVGIcon>
);
